var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 7.65a.83.83 0 0 0-.72-.56L12.8 6.7l-2.05-4.55a.83.83 0 0 0-1.52 0L7.18 6.7l-4.75.38a.83.83 0 0 0-.51 1.42l3.5 3.43L4.2 17.3a.83.83 0 0 0 1.27.88L10 15.17l4.54 3.02a.83.83 0 0 0 1.26-.92l-1.52-5.33 3.78-3.4a.83.83 0 0 0 .23-.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default ForwardRef;